/**
 * Interim quantity stepper.
 *
 * global.js's <quantity-input> element (which steps the value and calls
 * updatePriceDisplay) is lazy-loaded on first interaction, so the +/- buttons
 * and the price wouldn't respond until then. This lightweight, dependency-free
 * handler mirrors QuantityInput's step logic and updates the price immediately.
 *
 * It ENDS the moment global.js registers <quantity-input>: customElements
 * .whenDefined resolves and we remove the listener, so global.js takes over
 * cleanly with no double-stepping. (onClick also self-removes as a safety net.)
 */
(function () {
  function takeover() {
    document.removeEventListener("click", onClick);
  }

  function onClick(event) {
    // Global.js has taken over — stop handling and detach.
    if (window.customElements && customElements.get("quantity-input")) {
      takeover();
      return;
    }

    const button = event.target.closest("quantity-input .quantity__button");
    if (!button) return;
    event.preventDefault();

    const wrapper = button.closest("quantity-input");
    const input = wrapper && wrapper.querySelector(".quantity__input");
    if (!input) return;

    const prev = input.value;
    if (button.name === "plus") {
      if (parseInt(input.dataset.min) > parseInt(input.step) && input.value == 0) {
        input.value = input.dataset.min;
      } else {
        input.stepUp();
      }
    } else {
      input.stepDown();
    }

    if (prev === input.value) return;

    const value = parseInt(input.value);
    if (typeof window.updatePriceDisplay === "function") window.updatePriceDisplay(value);
    if (typeof window.updateMegaSalePrice === "function") window.updateMegaSalePrice(value);
  }

  document.addEventListener("click", onClick);

  // End as soon as global.js defines the real element.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("quantity-input").then(takeover);
  }
})();
